import { Box, Heading } from '@grupoboticario/flora-react'
import { useTranslation } from 'react-i18next'
import { useTracking } from '../TrackingContext'

const TrackingID = () => {
  const data = useTracking()
  const { t } = useTranslation()

  if (!data) return <div />

  return (
    <Box css={{ display: 'flex' }}>
      <Box
        css={{
          width: '100%'
        }}
      >
        <Heading as="h1" css={{ fontSize: '32px', lineHeight: '36px', fontWeight: 500, padding: '5px 0' }}>
          {t('orderTracking')}: {data.orderTraceabilityModel.nmPedidoExpedidor}
        </Heading>
      </Box>
    </Box>
  )
}

export default TrackingID
